import React from 'react';
import Profile from './Profile';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';

const ContentGenerationProfile = () => {
  return (
    <BasePageContainer>
      <Profile />
    </BasePageContainer>
  );
};

export default ContentGenerationProfile;
